import { createContext, useContext, useEffect, useState } from "react";
import { adminApi, TOKEN_KEY } from "./api";

const AuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out

  useEffect(() => {
    if (!window.location.pathname.startsWith("/admin")) {
      setUser(false);
      return;
    }
    adminApi
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await adminApi.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await adminApi.post("/auth/logout");
    } catch {}
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAdminAuth = () => useContext(AuthContext);
